export const CREATE_VARIABLE_DATA_TYPE = 'CREATE_VARIABLE_DATA_TYPE';
export const UPDATE_VARIABLE_DATA_TYPE = 'UPDATE_VARIABLE_DATA_TYPE';